import type { InjectionKey } from 'vue';
import type { RouteLocationRaw } from 'vue-router';

export type FileDetailsRouteResolver = (fileId: string) => RouteLocationRaw;

/**
 * Опциональный resolver маршрута карточки файла.
 * Задаётся в admin через `provide`; в shared не прошивается имя маршрута.
 */
export const FILE_DETAILS_ROUTE_KEY: InjectionKey<FileDetailsRouteResolver> = Symbol(
  'fileDetailsRoute'
);

/**
 * Разрешён ли выбор файла из ранее загруженных (`ExistingFilePicker`).
 * На portal задаётся `false` через `provide` в boot; в admin по умолчанию `true`.
 */
export const ALLOW_PICK_EXISTING_FILES_KEY: InjectionKey<boolean> = Symbol(
  'allowPickExistingFiles'
);
